/*
Sohel 11/16/2022 2700912712 Implemented Field List Screen
Sohel 11/16/2022 2700912712 Save API Payload Changes.
Sohel 11/17/2022 2700912712 Conditionally added Save API Payalod.
Sohel 11/17/2022 2700912712 added deleted Id Save API Payalod.
Sai Maheshwar 11/18/2022 2700912712 fixed SQL rule clear issue
Sohel 11/19/2022 2700912712 Added override functionality
Prakash 11/23/2022 2700912712 Increased Font size of Accordion header.
Sohel 12/01/2022 2700912712 Added Override Type in payload.
Sohel 12/04/2022 2700912712 Accordion changes.
Sohel 12/04/2022 2700912712 fixed Sql Rules copy issue.
Saikrishna 12/09/2022 2700912712 save and stay in page functionality added.
rajesh 12/12/2022 2700912712 reset selected data when user is not saving
Suresh Peddavoora 12/13/2022 2700912712 Fixed Button Spacing Alignments
Sohel 12/13/2022 2700912712 conditionally hide Save Button
akhila 12/15/2022 2700912712 adding new Ui for select Fields
lalitha 15/12/2022 2700912712 added access role in filter rule group
Ashraf 15/12/2022 2700912712 fixed role access.
akhila 12/18/2022 2700912712 fixed unsaved changes popup
akhila 12/19/2022 2700912712 fixed payload issues
akhila 12/20/2022 2700912712 fixed save disabled
akhila 12/20/2022 2700912712 changed overRide title
sai Krishna 12/23/2022 2700912712 add  filtercode, Reportcode  and filter description
akhila 12/23/2022 2700912712 added dbTableName in select fields payload
akhila 12/23/2022 2700912712 added deleteIds in payload
akhila 12/26/2022 2700912712 fixed payload deleteids
Ashraf 01/02/2023 2700912712 renamed usage header title
kavyareddy 01/04/2023 2700912712 fixed category issue in filter
Akhila 01/26/2023 2700912712 Added handleDirty for unsaved Changes alert popup
Raghu 02/21/2023 2700912712 changed buttons color
Sohel 06/20/2023 2700912712 Enabled Save Button
Ravi 06/20/2023 2700912712 Added Breadcrums in popup
Akhila 06/21/2023 2700912712 conditionally disable save and finish button on submission
Sohel 10/05/2023 2698811066 Filter Criteria  Added Table Column Name and Field Name Changes
Gireesh 15-12-2023 2700912712 updated payload
*/
import React, {useState, useEffect} from 'react';
import {Button, makeStyles, Tooltip} from '@material-ui/core';
import {ArrowBack} from '@material-ui/icons';
import {useSelector, useDispatch} from 'react-redux';
import reusableInputStyles from '../../../../components/InputStyles';
import {
  postFilterRuleGroup,
  resetMessage,
  fetchFilterRuleGroup,
  ResetAddRule as resetAddRule,
} from '../../../../redux/reducers/BRE/FilterRuleGroup';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import PageLoader from '../../../../components/PageLoader';
import {
  fetchGlobalFieldListData,
} from '../../../../redux/reducers/GlobalField/AddFieldList';
import {useRef} from 'react';
import OverrideRule from '../../../../components/OverrideRule';
import SearchFields from '../../GlobalFields/DataRepositories/SearchDataRepositories/index';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import DialogBox from './../../../../components/DialogBox/index';
import FilterTable from './FilterTable';
import {
  postFormulaFields,
  resetFormula,
  postFormulaSelectFields,
} from '../../../../redux/reducers/BRE/AddRuleGroup';
import BreadCrums from '../../../../util/BreadCrum';
import {submissionStart} from '../../../../redux/reducers/CommonActions/commonActions';

const useStyles = makeStyles((theme) => ({
  goBackBtn: {
    padding: '6px 12px',
    color: '#320469',
    marginBottom: '10px',
  },
  root: {
    'width': '100%',
    'backgroundColor': '#fff',
    'borderRadius': '4px',
    'border': '1px solid #f3f3f3',
    'marginTop': 10,
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
      backgroundColor: '#fff',
    },
    '& .MuiAccordionSummary-root': {
      backgroundColor: '#f3f3f3',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  detailsCard: {
    padding: 10,
    borderRadius: '0px 0px 8px 8px',
    backgroundColor: '#fbfbfb',
  },
}));
const StepperFieldList = ({
  setFieldListCode,
  handleBack,
  handleNext,
  fieldList,
  setFieldList,
  rowSelected: editExisting,
  handleDirty,
}) => {
  const componentClasses = useStyles();
  const deleteSql = useRef([]);
  const classes = reusableInputStyles();
  const [showSearch, setShowSearch] = useState(false);
  const [isCopyData, setIsCopyData] = useState(false);
  const [dialogState, setDialogState] = useState(false);
  const [overRiding, setOverRiding] = useState({});
  const [open, setOpen] = useState(false);
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [filterFields, setFilterFields] = useState([]);
  const [deletedIds, setDeletedIds] = useState([]);
  const dispatch = useDispatch();
  const saveRef = useRef();
  const {
    loading,
    successMsg,
    errorMsg,
    filterRuleGroupData,
    filterRuleGroupId,
    addRuleData,
    userMetrix,
    addRuleStatus,
  } = useSelector(({addFilterRuleGroup}) => addFilterRuleGroup);
  const {formulaFieldsData, addFormulaFieldsStatus} = useSelector(
    ({addRuleGroup}) => addRuleGroup,
  );
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  useEffect(() => {
    setIsCopyData(false);
  }, []);
  const {roleData} = useSelector(({role}) => role);
  const filterRuleRoleAccess = roleData?.window?.['Filter Rules']?.['FR'];
  const handleDialogState = () => {
    setDialogState(false);
  };
  // useEffect(() => {
  //   if (!fieldListCode) {
  //     setExpanded(false);
  //   }
  // }, [fieldListCode]);
  useEffect(() => {
    if (filterRuleGroupId) {
      dispatch(fetchFilterRuleGroup(filterRuleGroupId));
    }
  }, [filterRuleGroupId]);
  useEffect(() => {
    if (filterRuleGroupData?.fieldListCode) {
      setFieldList(filterRuleGroupData?.fieldListCode);
      setFieldListCode(filterRuleGroupData?.fieldListCode);
    }
  }, [filterRuleGroupData?.fieldListCode]);
  const handleSubmit = () => {
    dispatch(submissionStart());
    // const deletedId =filterRuleGroupData?.filterSQLRuleResponse?.length > 0 ? filterRuleGroupData?.filterSQLRuleResponse?.map(i => i.id) :[]
    const payload = {
      sqlRules: filterRuleGroupData?.filterSQLRuleResponse ?
        filterRuleGroupData?.filterSQLRuleResponse :
        [],
      id: filterRuleGroupData?.id ? filterRuleGroupData?.id : filterRuleGroupId,
      sqlDeletedId: deleteSql.current,
      override: 'No',
      code: filterRuleGroupData?.code ? filterRuleGroupData?.code : '',
      description: filterRuleGroupData?.description ? filterRuleGroupData?.description : '',
      displayName: filterRuleGroupData?.displayName ? filterRuleGroupData?.displayName : '',
      sqlExpression:
        filterRuleGroupData?.fieldListCode === fieldList && filterRuleGroupData?.sqlExpression ?
          filterRuleGroupData?.sqlExpression :
          '',
      category: '',
      fieldListCode: fieldList,
      isDraft:
        filterRuleGroupData?.fieldListCode === fieldList && filterRuleGroupData?.isDraft ?
          filterRuleGroupData?.isDraft :
          'Y',
      oldFilterRuleGroupCode: '',
      overrideType: 'FILTER',
    };

    const obj = {};
    const obj2 = {};
    formulaFieldsData?.forEach((row) => {
      obj[row?.repositoryName + row?.fieldName] = row?.formulaFieldMapId;
      obj2[row?.repositoryName + row?.fieldName] = row?.formulaFieldMapId;
    });
    // {abc123:100}
    filterFields?.forEach((row2) => {
      if (obj[row2?.repositoryName + row2?.fieldName]) {
        delete obj[row2?.repositoryName + row2?.fieldName];
      }
    });
    const data =
      filterFields?.length > 0 &&
      filterFields?.map((item, i) => {
        const existingIds = obj2[item?.repositoryName + item?.fieldName] ?
          obj2[item?.repositoryName + item?.fieldName] :
          null;
        return {
          category: item?.category ? item.category : '',
          dataType: item?.fieldType ? item.fieldType : '',
          fieldName: item?.fieldName ? item?.fieldName : '',
          formulaFieldMapId: item?.formulaFieldMapId ?
            item?.formulaFieldMapId :
            existingIds ?
              existingIds :
              0,
          groupCode: filterRuleGroupData?.code ? filterRuleGroupData?.code : '',
          repositoryName: item?.repositoryName ? item?.repositoryName : '',
          ruleType: 'Filters',
          dbTableName: item?.dbTableName ? item?.dbTableName : '',
          dbColumnName: item?.tableColumnName ? item?.tableColumnName : '',
          filterFormulaGroupId:filterRuleGroupData?.id,
          dataRepositoryId: item?.dataRepositoryId ? item?.dataRepositoryId : 0,
          fieldId: item?.repositoryFieldId
            ? item?.repositoryFieldId
            : 0,
        };
      });
    const passValues = {
      formulaFieldsRequest: data,
      deleteDataCalculationsFilterIds: Object.values(obj),
    };
    dispatch(postFormulaFields(passValues));
    setOverRiding(payload);
    // dispatch(postFilterRuleGroup(payload));
  };

  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 1000);
    }
  }, [errorMsg, successMsg]);
  useEffect(() => {
    if (addRuleStatus === 200 && userMetrix === 'Yes') {
      setDialogState(true);
      setTimeout(() => {
        dispatch(resetAddRule());
      }, 2500);
    }
  }, [userMetrix, addRuleStatus]);

  useEffect(() => {
    if (fieldList && !showSearch) {
      dispatch(fetchGlobalFieldListData(fieldList));
    }
  }, [fieldList, showSearch]);

  useEffect(() => {
    if (!isCopyData && filterRuleGroupData?.fieldListCode) {
      setFieldList(fieldList ? fieldList : filterRuleGroupData?.fieldListCode);
      setFieldListCode(fieldList ? fieldList : filterRuleGroupData?.fieldListCode);
    }
  }, [isCopyData, filterRuleGroupData?.fieldListCode]);

  useEffect(() => {
    if (addFormulaFieldsStatus === 200) {
      setTimeout(() => {
        dispatch(resetFormula());
        !saveRef.current && handleNext();
        dispatch(
          postFormulaSelectFields({
            groupCode: filterRuleGroupData?.code ? filterRuleGroupData?.code : '',
            ruleType: 'Filters',
            filterFormulaRuleGroupId:filterRuleGroupData?.id || 0 ,
          }),
        );
      }, 2500);
    }
  }, [addFormulaFieldsStatus]);

  useEffect(() => {
    if (Object.keys(formulaFieldsData).length > 0 && filterRuleGroupData?.code) {
      const formulaTableData = formulaFieldsData?.map((field) => {
        return {
          category: field?.category,
          formulaFieldMapId: field?.formulaFieldMapId,
          fieldName: field?.fieldName,
          fieldType: field?.dataType,
          repositoryName: field?.repositoryName,
          repositoryType: field?.repositoryType,
          tableColumnName: field?.dbColumnName,
          dataRepositoryId: field?.dataRepositoryId ? field?.dataRepositoryId : 0,
          repositoryFieldId: field?.fieldId ? field?.fieldId : 0,
        };
      });

      setFilterFields(formulaTableData);
    }
  }, [formulaFieldsData, filterRuleGroupData?.code]);

  useEffect(() => {
    if(filterRuleGroupData?.id){
      dispatch(
        postFormulaSelectFields({
          groupCode: filterRuleGroupData?.code ? filterRuleGroupData?.code : '',
          ruleType: 'Filters',
          filterFormulaRuleGroupId:filterRuleGroupData?.id || 0 ,
        }),
      );
    }
  }, [filterRuleGroupData?.id]);

  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {showSearch && (
        <Button
          variant="text"
          className={`"mb-2" ${componentClasses.goBackBtn}`}
          onClick={() => {
            setShowSearch(false);
          }}
        >
          <ArrowBack className="mr-2" />
          Go Back
        </Button>
      )}
      <div>
        <BreadCrums
          name={'Filter Name'}
          code={filterRuleGroupData?.code}
          description={'Filter Description'}
          descriptionValue={filterRuleGroupData?.description}
        />
      </div>

      <div className="new-standard-textfields table-header table-card-header justify-content-end">
        <Button
          variant="outlined"
          className={`search-btn ${classes.buttonRoot}`}
          onClick={() => setOpen(true)}
          startIcon={<AccountTreeIcon />}
        >
          Map Fields
        </Button>
      </div>
      <FilterTable
        setFilterFields={setFilterFields}
        filterFields={filterFields}
        deletedIds={deletedIds}
        setDeletedIds={setDeletedIds}
        handleDirty={handleDirty}
      />
      <DialogBox
        open={open}
        dialogClose={handleClose}
        // title="Search Repository Fields"
        title={
          <div className="dialog-breadcrum">
            <p className="dialoge-title-breadcrum">
              <b> Search Repository Fields</b>
            </p>
            <BreadCrums
              name={'Filter Name'}
              code={filterRuleGroupData?.code}
              description={'Filter Description'}
              descriptionValue={filterRuleGroupData?.description}
            />
          </div>
        }
        maxWidth="xl"
      >
        <SearchFields
          setFilterFields={setFilterFields}
          filterFields={filterFields}
          setTempSelectedRows={setTempSelectedRows}
          tempSelectedRows={tempSelectedRows}
          //  StepperFieldList={true}
          isReports={true}
          mapFields={true}
          // isFormulaTrue = {true}
          handleClose={handleClose}
          handleDirty={handleDirty}
          deletedIds={deletedIds}
          setDeletedIds={setDeletedIds}
        />
      </DialogBox>
      <div className="new-standard-textfields d-flex justify-content-center mt-3">
        <Button
          variant="outlined"
          onClick={() => {
            handleBack();
            setFieldList('');
          }}
          className={`reset-btn mr-1 ${classes.buttonRoot}`}
        >
          Back
        </Button>
        {/* {filterRuleGroupData?.isDraft === "N" && ( */}
        <Button
          variant="outlined"
          type="submit"
          disabled={
            filterFields?.length === 0 ||
            (!filterRuleRoleAccess?.edit && formulaFieldsData?.length > 0 && editExisting) ||
            enabledSubmission
          }
          className={`search-btn mx-1 ${classes.buttonRoot}`}
          onClick={() => {
            saveRef.current = true;
            handleDirty(false, 'fixed');
            handleSubmit();
          }}
        >
          Save
        </Button>
        {/* )} */}
        <Tooltip title={filterFields?.length === 0 ? 'Please Add AtLeast one Field' : ''}>
          <span>
            <Button
              variant="outlined"
              onClick={() => {
                saveRef.current = false;
                handleSubmit();
                // handleNext();
              }}
              disabled={
                filterFields?.length === 0 ||
                (!filterRuleRoleAccess?.edit && formulaFieldsData?.length > 0 && editExisting) ||
                enabledSubmission
              }
              className={`search-btn ml-1 ${classes.buttonRoot}`}
            >
              Save & Next
            </Button>
          </span>
        </Tooltip>
      </div>
      <OverrideRule
        dialogTitle="Override Rule"
        dialogOpen={dialogState}
        dialogClose={handleDialogState}
        title={`This Filter Rule has been used in the following places.`}
        handleOverrideClose={handleDialogState}
        handleOverrideSubmit={() => {
          dispatch(postFilterRuleGroup({...overRiding, override: 'Yes'}));
          handleDialogState();
        }}
        data={addRuleData}
      />
      {loading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default StepperFieldList;
